<script lang="ts">
	import type { Lightshow, Folder, Media, Scene } from "luxedo-data"
	import { Toast } from "toaster"
	import type { MaskBase } from "luxedo-canvas/asset"
	import { FileLabel } from "misc-ui"

	interface Props {
		file: Scene | Media | Folder | Lightshow | MaskBase
		onRename: (newName: string) => void
		triggerRename?: () => void
	}

	let { file, onRename, triggerRename = $bindable() }: Props = $props()
</script>

<FileLabel
	fileId={file.id}
	fileName={file.name}
	fileType={file.constructor.name}
	{onRename}
	bind:triggerRename
/>

<style>
</style>
